<template>
  <div class="operate_box">
    <van-button type="default" size="small" round text="说两句..." class="comment_btn" @click="showCommentForm" v-if="allowComment"></van-button>
    <van-button type="default" size="small" round text="说两句..." class="comment_btn" disabled v-else></van-button>
    <div class="operate_right">
      <span class="comment" @click="onCommentClick($event)">
        <Icon iconClass="comment" v-if="isTop" />
        <Icon iconClass="text" v-else />
      </span>
      <span class="praise" v-if="allowLike != false && allowLike != 0">
        <Icon iconClass="candle" @click="cancelPraiseHandler" v-if="isLiked == true && likeType == '10'" />
        <Icon iconClass="pray" @click="cancelPraiseHandler" v-else-if="isLiked == true && likeType=='11'" />
        <Icon iconClass="praise" @click="cancelPraiseHandler" v-else-if="isLiked == true" />
        <Icon iconClass="candle-o" @click="praiseHandler" v-if="isLiked == false && likeType == '10'" />
        <Icon iconClass="pray-o" @click="praiseHandler" v-else-if="isLiked == false && likeType=='11'" />
        <Icon iconClass="praise-o" @click="praiseHandler" v-else-if="isLiked == false" />
      </span>
      <span class="collect">
        <Icon iconClass="star" @click="cancelCollectHandler" v-if="collected==1||collected==true" />
        <Icon iconClass="star-o" @click="addCollectHandler" v-else />
      </span>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { addScore } from "@/utils";
import commApi from "@/api/apis/common.js";
export default {
  name: "Operate",
  props: {
    params: {
      type: Object,
      default: null,
    },
    id: {
      type: Number,
      default: "",
    },
    contentId: {
      type: Number,
      default: "",
    },
    contentTitle: {
      type: String,
      default: "",
    },
    isCollect: {
      type: Number,
      default: 0,
    },
    allow: {
      type: Boolean,
      default: false,
    },
    likeType: {
      type: String,
      default: "",
    },
    allowLikes: {
      type: Number,
      default: 1,
    },
  },
  computed: {
    ...mapState("app", ["userInfo", "deviceId"]),
  },
  data() {
    return {
      isTop: true, //默认显示顶部
      allowComment: false,
      allowLike: true,
      isLiked: false, // 是否已点赞
      collected: 0, // 是否已收藏
    };
  },
  watch: {
    isCollect: {
      handler(newValue, oldValue) {
        this.collected = newValue;
      },
      deep: true,
    },
    allow: {
      handler(newValue, oldValue) {
        this.allowComment = newValue;
      },
      deep: true,
    },
    allowLikes: {
      handler(newValue, oldValue) {
        this.allowLike = newValue;
      },
      deep: true,
    }
  },
  methods: {
    /* 获取点赞状态 */
    getThumbsUpStatus() {
      var _this = this;
      var params = {
        contentType: _this.params.contentType,
        contentId: _this.id,
        fromFlag: _this.params.fromFlag,
      };
      if (!!_this.userInfo) {
        params.memberId = _this.userInfo.id;
      } else {
        params.deviceId = _this.deviceId;
      }
      commApi
        .queryThumbsUpStatus(params)
        .then((res) => {
          if (res.suc == 1) {
            if (res.data.userLikes == 1) {
              var target = _this.$refs.praise;
              target.classList.add("praised");
              _this.isLiked = true;
            }
          } else {
            _this.$toast({
              message: res.message || res.text,
              position: "center",
            });
          }
        })
        .catch((err) => {
          _this.$toast({
            message: "接口调用出错",
            position: "center",
          });
        });
    },
    /* 显示评论表单 */
    showCommentForm() {
      if (this.allowComment) {
        if (!!this.userInfo) {
          this.$emit("showCommentForm", true);
        } else {
          this.$router.push("/login");
        }
      }
    },
    /* 滚动到评论区域或顶部 */
    onCommentClick(event) {
      var _this = this;
      var target = event.currentTarget;
      var clsArray = target.firstElementChild.classList;
      if (clsArray.contains("tj-icon-comment")) {
        _this.isTop = false;
        _this.$emit("isToComment", true);
      } else {
        _this.isTop = true;
        _this.$emit("isToComment", false);
      }
    },
    /* 点赞 */
    praiseHandler() {
      var _this = this;
      var params = {
        contentType: _this.params.contentType,
        contentId: _this.id,
        fromFlag: _this.params.fromFlag,
      };
      if (!!_this.userInfo) {
        params.memberId = _this.userInfo.id;
      } else {
        params.deviceId = _this.deviceId;
      }

      commApi
        .giveThumbsUp(params)
        .then((res) => {
          if (res.suc == 1) {
            _this.isLiked = true;
            _this.addScore("dz"); // 点赞增加积分
          } else {
            _this.$toast({
              message: res.message || res.text,
              position: "center",
            });
          }
        })
        .catch((err) => {
          _this.$toast({
            message: "接口调用出错",
            position: "center",
          });
        });
    },
    /* 取消点赞 */
    cancelPraiseHandler() {
      var _this = this;
      var params = {
        contentType: _this.params.contentType,
        contentId: _this.id,
        fromFlag: _this.params.fromFlag,
      };
      if (!!_this.userInfo) {
        params.memberId = _this.userInfo.id;
      } else {
        params.deviceId = _this.deviceId;
      }
      commApi
        .cancelThumbsUp(params)
        .then((res) => {
          if (res.suc == 1) {
            _this.isLiked = false;
          } else {
            _this.$toast({
              message: res.message || res.text,
              position: "center",
            });
          }
        })
        .catch((err) => {
          _this.$toast({
            message: "接口调用出错",
            position: "center",
          });
        });
    },
    /* 收藏 */
    addCollectHandler() {
      var _this = this;
      if (!!_this.userInfo) {
        var params = {
          contentType: _this.params.contentType,
          contentId: _this.contentId,
          isSpecial: _this.params.fromFlag,
          memberId: _this.userInfo.id,
        };

        commApi
          .addMemberCollect(params)
          .then((res) => {
            if (res.suc == 1) {
              _this.collected = 1;
              _this.addScore("sc"); // 收藏增加积分
            } else if (res.message == "该内容已收藏") {
              _this.collected = 1;
            } else {
              _this.$toast({
                message: res.message || res.text,
                position: "center",
              });
            }
          })
          .catch((err) => {
            _this.$toast({
              message: "接口调用出错",
              position: "center",
            });
          });
      } else {
        _this.$router.push("/login");
      }
    },
    /* 取消收藏 */
    cancelCollectHandler(event) {
      var _this = this;
      if (!!_this.userInfo) {
        var params = {
          contentType: _this.params.contentType,
          contentId: _this.contentId,
          isSpecial: _this.params.fromFlag,
          memberId: _this.userInfo.id,
        };
        commApi
          .cancelMemberCollect(params)
          .then((res) => {
            if (res.suc == 1) {
              _this.collected = 0;
            } else {
              _this.$toast({
                message: res.message || res.text,
                position: "center",
              });
            }
          })
          .catch((err) => {
            _this.$toast({
              message: "接口调用出错",
              position: "center",
            });
          });
      } else {
        _this.$router.push("/login");
      }
    },
    /* 增加积分 */
    addScore(code) {
      let desc = "";
      if (code == 'dz') {
        desc = "点赞";
      } else if (code == 'sc') {
        desc = "收藏";
      }
      let jf_params = {
        code: code, // 必传 (xsgg、fxcg、lnr、tpdcfbcg、gksp、gkyp、zbj、dy、dz、sc)
        description: desc, // 必传，积分类型描述 (欣赏广告、分享内容、浏览内容、参与投票、观看视频、观看音频、直播间、订阅、点赞、收藏)
        contentType: this.params.contentType, // 非必传，稿件的type
        contentId: this.params.contentId, // 非必传，稿件的id
        contentName: this.contentTitle, // 非必传，稿件的标题
      }
      if (!!this.userInfo) {
        jf_params = Object.assign(jf_params, {
          memberId: this.userInfo.id, //会员id
        });
      }
      addScore(jf_params);
    },
  },
  created() {
    this.allowComment = this.allow;
    this.allowLike = this.allowLikes;
    this.collected = this.isCollect;
    this.getThumbsUpStatus(); //获取点赞状态
  },
};
</script>
<style scoped lang="scss">
.operate_box {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 5;
  display: flex;
  width: 100%;
  height: 40px;
  padding: 5px 15px;
  background-color: #fff;
  border-top: 1px solid #ebedf0;
  .comment_btn {
    width: 100%;
    height: 30px;
    background: #ebedf0;
    border: none;
    font-size: 14px;
    color: #b3b3b3;
    .van-button__content {
      padding-left: 10px;
      padding-right: 10px;
      -webkit-justify-content: normal;
      justify-content: normal;
      text-align: left;
    }
  }
  .operate_right {
    flex: none;
    width: 93px;
    height: 30px;
    line-height: 30px;
    padding-left: 5px;
    text-align: right;
    .comment {
      margin-left: 10px;
    }
    .praise {
      margin-left: 10px;
    }
    .collect {
      margin-left: 10px;
    }
    .tj-svg-icon {
      color: #bebebe;
      vertical-align: middle;
      &.tj-icon-comment {
        font-size: 18px;
      }
      &.tj-icon-text {
        font-size: 16px;
      }
      &.tj-icon-praise-o {
        font-size: 20px;
      }
      &.tj-icon-candle-o {
        font-size: 20px;
        vertical-align: -0.25em;
      }
      &.tj-icon-pray-o {
        font-size: 20px;
      }
      &.tj-icon-star-o {
        font-size: 20px;
      }
      &.tj-icon-praise {
        font-size: 20px;
        color: #318bff;
      }
      &.tj-icon-candle {
        font-size: 20px;
        color: #318bff;
        vertical-align: -0.25em;
      }
      &.tj-icon-pray {
        font-size: 20px;
        color: #318bff;
      }
      &.tj-icon-star {
        font-size: 20px;
        color: #318bff;
      }
    }
  }
}
</style>